const findProp = (prop: string, obj: unknown): unknown => {
  if (typeof obj !== 'object' || obj === null) return null
  if (typeof prop !== 'string') throw Error('Property has to be a string! ')

  const record = obj as Record<string, unknown>
  if (record[prop]) return record[prop]

  let propValue: unknown = null
  for (const key in record) {
    propValue = findProp(prop, record[key])
    if (propValue !== null) break
  }
  return propValue
}

const findDeepProp = (props: string | string[], obj: unknown): unknown => {
  if (typeof props !== 'string' && !Array.isArray(props)) {
    throw Error('Property has to be a string or array!')
  }
  if (typeof props === 'string') return findDeepProp(props.split('.'), obj)

  const element = props.shift() as string
  let propValue = findProp(element, obj)
  if (propValue !== null && props.length > 0) {
    propValue = findDeepProp(props, propValue)
  }
  return propValue
}

const arrayToObject = <T extends Record<string, any>>(arr: T[], keyField: keyof T) =>
  Object.assign({}, ...arr.map((item) => ({ [item[keyField]]: item })))

export { arrayToObject, findDeepProp }
